import script from "./NotificationsInfoCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsInfoCards.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard});
